<template>
  <div class="availability">
    <span class="availability__name">{{ name }}</span>
    <div v-if="availability.points" class="availability__points">
      <vb-icon class="availability__icon" :name="'wallet'" :color="sass('gray-900')" :size="16" />
      <span>{{ availability.points.label || 'Punti Fedeltà' }}:</span>
      <img
        :src="availability.points.iconUrl || 'assets/images/common/statics/fallback_loyalty.png'"
        alt=""
      />
      <span>{{ availability.points.total }}</span>
    </div>
    <template v-else>
      <div v-if="availability.total >= 0" class="availability__credits">

        <div v-if="availability.is_known" class="d-flex align-items-center">
          <vb-icon class="availability__icon" :name="'wallet'" :color="sass('gray-900')" :size="16" />
          <span>Credito:</span>
          <strong>€ {{ availability.total }}</strong>
        </div>

        <div v-if="availability.total !== availability.details.integration && !availability.details.discount_codes">
          <span>Credito Welfare:</span>
          <strong>€ {{ availability.details.integration }}</strong>
        </div>

        <div v-if="availability.details.discount_codes" class="d-flex align-items-center">
          <vb-icon class="availability__icon" :name="'ticket'" :color="sass('gray-900')" :size="16" />
          <span>Codici Sconto:</span>
          <strong>€ {{ availability.details.discount_codes }}</strong>
        </div>
      </div>
    </template>
  </div>
</template>

<script>

export default {
  name: 'availability',

  components: {
  },

  props: {
    name: {
      type: String,
      default: '',
    }
  },

  data() {
    return {
    }
  },

  computed: {

    availability() {
      return this.get_availability()
    },
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .availability {

    &__name {
      font-weight: $vb-font-weight-semibold;
      color: $primary;
    }

    &__icon {
      margin-right: $grid-gutter-width / 6;
    }

    &__points {
      display: flex;
      align-items: center;

      span {
        &:nth-child(2) {
          margin-right: $grid-gutter-width / 6;
          text-transform: capitalize;
        }

        &:last-child {
          font-weight: $vb-font-weight-semibold;
        }
      }

      img {
        max-width: 15px;
        margin-right: $grid-gutter-width / 6;
      }
    }

    &__credits {
      display: flex;
      align-items: center;

      strong {
        margin-left: $grid-gutter-width / 6;
        font-weight: $vb-font-weight-semibold;
        color: $gray-900;
      }
    }
  }

</style>